import { createContext, useContext, useEffect, useRef, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = user
  const manualAuth = useRef(false); // prevents the initial /me check from clobbering an explicit login

  useEffect(() => {
    api
      .get("/auth/me")
      .then((res) => {
        if (!manualAuth.current) setUser(res.data);
      })
      .catch(() => {
        if (!manualAuth.current) setUser(false);
      });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.access_token) localStorage.setItem("cha_token", data.access_token);
    manualAuth.current = true;
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      /* ignore */
    }
    localStorage.removeItem("cha_token");
    manualAuth.current = true;
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
